import { render, staticRenderFns } from "./Jitsi.vue?vue&type=template&id=5678c8c7&scoped=true&"
import script from "./Jitsi.vue?vue&type=script&lang=ts&"
export * from "./Jitsi.vue?vue&type=script&lang=ts&"
import style0 from "./Jitsi.vue?vue&type=style&index=0&id=5678c8c7&lang=scss&scoped=true&"
import style1 from "./Jitsi.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5678c8c7",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarItems } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VIcon,VOverlay,VSpacer,VToolbar,VToolbarItems,VToolbarTitle})
